module.exports = __webpack_public_path__ + "static/media/twitter.f29106f6.png";